interface StoredUser {
  tenant_id?: string;
  email?: string;
}

export const getStoredUser = (): StoredUser => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}") || {};
  } catch {
    return {};
  }
};

export const getEmail = (): string => getStoredUser().email || "";
